import { Contact } from "../../bitrix/types/contact";
import { dbContact } from "../types/contact";
import {
  CONTACT_BUSINESS_FIELD,
  CONTACT_BUSINESS_PARNERUS,
  PARNERUS_SOURCE_FIELD,
} from "../../bitrix/accountConfig";

export const dbContactToBitrixMapper = (
  contact: dbContact,
  accountId: string,
  accountName?: string
): Contact => {
  return {
    NAME: contact.NAME,
    LAST_NAME: contact.LAST_NAME,
    // Requerimiento del cliente (ago 2026): telefonos y emails NO se guardan en
    // Bitrix. Quedan solo en DynamoDB, que es de donde los lee la UI.
    // PHONE: contact.PHONE ? [{ VALUE_TYPE: "WORK", VALUE: contact.PHONE }] : [],
    // EMAIL: contact.EMAIL ? [{ VALUE_TYPE: "WORK", VALUE: contact.EMAIL }] : [],
    UF_CRM_1787069571: contact.UF_STATUS,
    UF_CRM_1787069718: contact.UF_IRS_STATUS,
    UF_CRM_1787069987: contact.UF_OCUPATION,
    UF_CRM_1787070442: contact.UF_INTEREST,
    UF_CRM_1787070605: contact.UF_TYPE_OF_SERVICE,
    BIRTHDATE: contact.BIRTHDATE,
    UF_CRM_1787070953: contact.UF_ADDRESS,
    COMMENTS: contact.COMMENTS,
    UF_CRM_PARNERUS_ACCOUNT_ID: accountId,
    UF_CRM_1787069354: accountName, // Parnerus account name
    [PARNERUS_SOURCE_FIELD]: contact.SOURCE_ID,
    // First Contact (el Mediador) no va aca: una automatizacion lo borra en el
    // alta. Lo escribe setContactFirstContact justo despues de crear el contacto.
    // Todo lo que crea la app va marcado como Parnerus: sin esto se mezcla con
    // el resto de la cuenta y le pegan las automatizaciones de los otros negocios.
    [CONTACT_BUSINESS_FIELD]: CONTACT_BUSINESS_PARNERUS,
    TYPE_ID: "5",
  };
};
